/* eslint-disable camelcase */
import { newAxiosIns } from '@/libs/axios'

/**
 * Vuex module: KomAds Whitelist notifications
 * Manages pending whitelist account request count and 30s polling.
 *
 * State:
 * - pendingWhitelistAccountRequest: number of pending requests
 * - pendingTopup: number of pending topups
 * - pendingWhitelistAccountIssue: number of pending account issues
 * - accumulationNotification: total count of pending notifications
 *
 * Actions:
 * - fetchPendingCount: fetch count from API
 * - initPolling: start 30s polling
 */
export default {
  namespaced: true,
  state: {
    pendingWhitelistAccountRequest: 0,
    pendingTopup: 0,
    pendingWhitelistAccountIssue: 0,
    accumulationNotification: 0,
  },
  getters: {
    pendingWhitelistAccountRequest: state => state.pendingWhitelistAccountRequest,
    pendingTopup: state => state.pendingTopup,
    pendingWhitelistAccountIssue: state => state.pendingWhitelistAccountIssue,
    accumulationNotification: state => state.accumulationNotification,
  },
  mutations: {
    /**
     * Set current pending requests count
     * @param {Object} state - Vuex state
     * @param {number} count - pending count
     */
    SET_PENDING_WHITELIST_ACCOUNT_REQUEST(state, count) {
      state.pendingWhitelistAccountRequest = count
    },
    /**
     * Set current pending topup count
     * @param {Object} state - Vuex state
     * @param {number} count - pending count
     */
    SET_PENDING_TOPUP(state, count) {
      state.pendingTopup = count
    },
    /**
     * Set current pending whitelist account issue count
     * @param {Object} state - Vuex state
     * @param {number} count - pending count
     */
    SET_PENDING_WHITELIST_ACCOUNT_ISSUE(state, count) {
      state.pendingWhitelistAccountIssue = count
    },
    /**
     * Set current accumulation notification count
     * @param {Object} state - Vuex state
     * @param {number} count - accumulation count
     */
    SET_ACCUMULATION_NOTIFICATION(state, count) {
      state.accumulationNotification = count
    },
  },
  actions: {
    /**
     * Fetch pending whitelist requests count from API
     * @param {Object} context - Vuex action context
     * @returns {Promise<void>}
     */
    async fetchPendingCount({ commit }) {
      await newAxiosIns.get('komads/api/v1/admin/activities_count')
        .then(res => {
          const {
            unprocessed_topup,
            unprocessed_whitelist_account_request,
            unprocessed_whitelist_account_issue,
          } = res.data.data
          const pendingTopup = Number(unprocessed_topup) || 0
          const pendingWhitelistAccountRequest = Number(unprocessed_whitelist_account_request) || 0
          const pendingWhitelistAccountIssue = Number(unprocessed_whitelist_account_issue) || 0

          commit('SET_PENDING_WHITELIST_ACCOUNT_REQUEST', pendingWhitelistAccountRequest)
          commit('SET_PENDING_TOPUP', pendingTopup)
          commit('SET_PENDING_WHITELIST_ACCOUNT_ISSUE', pendingWhitelistAccountIssue)
          commit('SET_ACCUMULATION_NOTIFICATION', pendingTopup + pendingWhitelistAccountRequest + pendingWhitelistAccountIssue)
        }).catch(() => {
          commit('SET_PENDING_WHITELIST_ACCOUNT_REQUEST', 0)
          commit('SET_PENDING_TOPUP', 0)
          commit('SET_PENDING_WHITELIST_ACCOUNT_ISSUE', 0)
          commit('SET_ACCUMULATION_NOTIFICATION', 0)
        })
    },
  },
}
